











































































































import { Component, Mixins, Watch } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import PolicyInfoContent from "../components/policy-info-content.vue"
import PageMixin from "@/mixins/page"
import CompareHtml from "../components/compare-html.vue"
import policyService from "@/services/policy.service"
import { mapGetters } from "vuex"
import { InitConfig } from "./constant"
// 启用本地的tinymce不使用云端的tinymce
import "tinymce/tinymce"
import Editor from "@tinymce/tinymce-vue"
import "./formatpainter"
import { validURL } from "@/utils"

@Component({
    components: {
        PageHeader,
        PolicyInfoContent,
        Editor,
        CompareHtml
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["PolicyStatusMap", "textTypeMap", "areaMap"])
    }
})
export default class PolicyEdit extends Mixins(PageMixin) {
    readonly areaMap: any
    readonly textTypeMap: any
    readonly PolicyStatusMap: any
    loading = false
    btnLoading = false
    editor: any = null
    showPolicyCompare = false
    policyCompareHtml = ""
    policyInfo: any = {}
    policy_id: number = null
    tId = "vue-tinymce-" + +new Date() + ((Math.random() * 1000).toFixed(0) + "")
    preview_context = ""
    history_context = ""
    current_context = ""
    selectKey = 0
    software_id = 0
    textDate: { visible: boolean } = {
        visible: false
    }

    // 自定义链接弹出框数据
    linkModal = {
        visible: false,
        form: {
            linkText: "",
            linkType: "",
            customUrl: ""
        },
        rules: {
            linkText: [
                { required: true, message: "请输入链接文本", trigger: "blur" },
                { min: 1, max: 100, message: "链接文本长度在1到100个字符", trigger: "blur" }
            ],
            linkType: [{ required: true, message: "请选择链接类型", trigger: "change" }],
            customUrl: [
                { required: true, message: "请填写", trigger: "blur" },
                { validator: this.validatorUrl }
            ]
        },
        linkGroups: [] as any[],
        selectedText: "",
        loading: false
    }
    tinymceEditor: any

    // URL验证函数
    validatorUrl(rule: any, value: any, callback: any) {
        if (value && !validURL(value)) {
            callback("请输入正确的链接！")
        } else {
            callback()
        }
    }

    get initConfig() {
        return {
            tinymceId: this.tId,
            ...InitConfig,
            setup: (editor: any) => {
                this.tinymceEditor = editor // 保存编辑器实例
                // 注册自定义超链接按钮
                editor.ui.registry.addButton("customlink", {
                    icon: "link",
                    tooltip: "插入超链接",
                    onAction: () => {
                        this.openCustomLinkDialog()
                    }
                })
            }
        }
    }

    get statusStr() {
        const { status } = this.policyInfo
        return this.PolicyStatusMap[status] || ""
    }

    @Watch("current_context")
    async onContentChange() {
        try {
            const payload = {
                id: this.policy_id,
                content: this.current_context
            }
            const res = await policyService.privacyPolicyPreview(payload)
            this.preview_context = res || ""
            // @ts-expect-error 新开tab页预览通讯方法
            this.previewWindow?.setPreviewContet(this.preview_context)
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }

    get isNotShowSaveBtn() {
        // 【文本类型】属于“系统权限调用说明”、“个人信息收集清单”、“第三方信息数据共享清单”且【编制状态】=“法务编制中”，法务编辑时，不显示【暂存】按钮
        // 【文本类型】不属于“系统权限调用说明”、“个人信息收集清单”、“第三方信息数据共享清单”且【编制状态】=“合规编制中”，合规编辑时，不显示【暂存】按钮
        const { text_type, preparation_status } = this.policyInfo
        // 系统权限调用说明”、“个人信息收集清单”、“第三方信息数据共享清单
        const textMapKeys = [4, 5, 6]
        return (
            (textMapKeys.includes(text_type) && preparation_status === 1) ||
            (!textMapKeys.includes(text_type) && preparation_status === 2)
        )
    }

    get isContentRequired() {
        // 【编制状态】由“法务编制中”变为“合规编制中”且，【文本类型】不属于“系统权限调用说明”、“个人信息收集清单”、“第三方信息数据共享清单”，文本编辑器内容必填
        // 【编制状态】由“合规编制中”变为“编制完成”，文本编辑器内容必填
        const { text_type, preparation_status } = this.policyInfo
        const textMapKeys = [4, 5, 6]
        return (
            (!textMapKeys.includes(text_type) && preparation_status === 1) ||
            preparation_status === 2
        )
    }

    created() {
        this.policy_id = Number(this.$route.query.id)
        this.getDetail()
    }

    goBack() {
        this.$router.go(-1)
    }

    previewWindow: Window | null = null
    toPreview() {
        localStorage.setItem("policyPreviewContent", this.preview_context)
        // 使用 Vue Router 获取完整的 URL
        const routePath = this.$router.resolve({
            path: "/privacyPolicy/preview",
            query: {
                id: String(this.policy_id),
                type: "current"
            }
        }).href
        // 在新标签页中打开 URL
        this.previewWindow = window.open(routePath, "_blank")
    }
    async compare() {
        if (!this.showPolicyCompare) {
            try {
                const res = await policyService.getPreviousPolicy({
                    id: this.policy_id
                })
                this.history_context = res || ""
                if (!this.history_context) {
                    this.$message.warn("无历史版本记录")
                    return
                }
                this.showPolicyCompare = !this.showPolicyCompare
            } catch (error) {
                this.$message.error(`${error}`)
            }
        } else {
            this.showPolicyCompare = !this.showPolicyCompare
        }
    }
    async getDetail() {
        try {
            this.loading = true
            const res = await policyService.getPolicyInfo({
                id: this.policy_id
            })
            this.policyInfo = res || {}
            this.software_id = res.software_id
            this.current_context = this.policyInfo.content || ""
        } catch (error) {
            this.$message.error(`${error}`)
        } finally {
            this.loading = false
        }
    }

    async submit(is_commit: number) {
        const msg = is_commit === 1 ? "提交" : "暂存"
        if (!this.current_context && this.isContentRequired) {
            this.$message.warn("请填写富文本内容")
            return
        }
        try {
            this.btnLoading = true
            await policyService.updatePolicy({
                id: this.policy_id,
                content: this.current_context,
                is_commit
            })
            this.$message.success(`${msg}成功`)
            if (is_commit === 1) {
                this.$router.push({
                    path: "/policy/manage"
                })
            }
        } catch (error) {
            this.$message.error(`${error}`)
        } finally {
            this.btnLoading = false
        }
    }
    async openCustomLinkDialog() {
        // 获取选中的文本
        this.linkModal.selectedText = this.tinymceEditor.selection.getContent({ format: "text" })
        // 初始化表单数据
        this.linkModal.form = {
            linkText: this.linkModal.selectedText,
            linkType: "",
            customUrl: ""
        }
        // 获取链接选项
        this.$nextTick(async () => {
            // 获取链接选项
            await this.loadLinkOptions()
            // 强制更新以确保下拉框重置
            this.selectKey += 1
        })

        // 显示自定义链接弹出框
        this.linkModal.visible = true
    }

    async loadLinkOptions() {
        try {
            const { list = [] } = await policyService.getComparePolicyList({
                software_id: [this.software_id]
            })
            // 自定义链接始终放在第一位
            const customOption = {
                id: "custom",
                label: "自定义链接",
                value: "，选择后请自行填写链接地址"
            }
            const apiOptions = list.map((item: any) => ({
                id: item.id,
                label: `${item.software_name}（${this.textTypeMap[item.text_type]}）：${
                    this.areaMap[item.area]
                }`,
                value: item.policy_external_link
            }))
            this.$set(this.linkModal, "linkGroups", [customOption, ...apiOptions])
            return true
        } catch (error) {
            console.error("加载链接选项失败:", error)
            this.$set(this.linkModal, "linkGroups", [])
            return false
        }
    }

    // 处理链接类型变化
    handleLinkTypeChange(value: string) {
        if (value !== "custom") {
            this.linkModal.form.customUrl = ""
        }
    }

    // 自定义搜索过滤函数
    filterLinkOption(input: any, option: any) {
        // 跳过加载中的选项
        if (option.key === "loading") {
            return false
        }
        // 获取选项文本进行匹配
        const optionText = option.componentOptions?.children?.[0]?.text || ""
        return optionText.toLowerCase().includes(input.toLowerCase())
    }

    // 获取最终URL
    getFinalUrl(): string {
        if (this.linkModal.form.linkType === "custom") {
            return this.linkModal.form.customUrl
        } else if (this.linkModal.form.linkType && this.linkModal.form.linkType !== "custom") {
            // value（链接有重复的）值相同，控制台会报错，用ID转一下可解决此问题
            const linkValue = this.linkModal.linkGroups.find(
                (item: any) => item.id == this.linkModal.form.linkType
            )?.value
            return linkValue
        }
        return ""
    }

    // 处理链接提交
    handleLinkSubmit() {
        const linkText = this.linkModal.form.linkText
        const linkUrl = this.getFinalUrl()
        // 插入链接到编辑器
        if (this.tinymceEditor) {
            const linkHtml = `<a href="${linkUrl}" target="_blank">${linkText}</a>`
            this.tinymceEditor.execCommand("mceInsertContent", false, linkHtml)
        }

        // 关闭弹出框
        this.linkModal.visible = false

        this.$message.success("链接插入成功")
    }

    // 处理链接取消
    handleLinkCancel() {
        this.linkModal.visible = false
    }
}
